import { ArrowLeft, Search } from "lucide-react";
import type { FC } from "react";

export type SearchFilterButtonProps = {
  isSearchFilterOpen: boolean;
  onClick: () => void;
};

export const SearchFilterButton: FC<SearchFilterButtonProps> = ({
  isSearchFilterOpen,
  onClick,
}: SearchFilterButtonProps) => {
  return (
    <div
      className="tooltip tooltip-bottom tooltip-primary"
      data-tip={isSearchFilterOpen ? "絞り込みを閉じる" : "絞り込み"}
    >
      <button
        type="button"
        onClick={onClick}
        className={`flex items-center gap-1 border-2 border-primary rounded-full px-2.5 py-1 mr-4 ${
          isSearchFilterOpen ? "bg-primary text-white" : "bg-white text-primary"
        }`}
      >
        <ArrowLeft className="w-3.5 h-3.5" />
        <Search className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};
